import React from 'react';
import moment from 'moment';
import { convertMeterAuditAction } from '../../../../helpers/converters';
import { addUserRoleUpdateNotifier, userRole } from '../../../../helpers/userHelpers';
import { Info } from '../../../../components/tools/Icons';
import * as bootstrap from 'bootstrap';
import { UneditableTextInput } from '../../../../components/tools/BootstrapControls';
import serviceUrls from '../../../../constants/serviceUrls';
import * as apiCaller from '../../../../helpers/apiCaller'
import uiHelpers from '../../../../helpers/uiHelpers';
import { isStringNullOrEmpty } from '../../../../helpers/validators';

class MeterAudits  extends React.Component {

    #payloadModalElementId = "model_p_" + (new Date()).getTime();
    #payloadModal;

    #editMeterModalElemetnId = "model_editMeter_" + (new Date()).getTime();
    #editMeterModel;

    constructor(props) {
        super(props);
        this.state = {
            loadingEditMeter: false,
            editMeter:null
        };
        addUserRoleUpdateNotifier(() => {
            this.forceUpdate();
        });
    }

    async componentDidMount() {
        this.#payloadModal = new bootstrap.Modal(document.getElementById(this.#payloadModalElementId));
        this.#editMeterModel = new bootstrap.Modal(document.getElementById(this.#editMeterModalElemetnId));
    }

    onApiPayloadBtnClick = (audit) => {
        this.setState({payloadAudit:audit},()=>this.#payloadModal.show());
    }

    onEditMeterDetailsBtnClick = async (audit) => {
        this.setState({editMeter:null, loadingEditMeter:true})
        this.#editMeterModel.show();

        await apiCaller.post(serviceUrls.meter.getEditMeterDetails,{id:audit.editMeterId}).then(async (data)=>{
            this.setState({editMeter:data.editMeter, loadingEditMeter:false})
        })
    }

    renderInfoCorrectionRow = (changed, lable, originalValue, newValue, lastRow=false) =>{
        if(!changed) return null;
        return <div className={`row ${!lastRow&&"mb-3"}`}>
                    <div class="col-md-4 py-2">{lable}</div>
                    <div className={"col-md-8"}>
                        <div class="card bg-light mb-3">
                            <div class="card-body p-2 text-wrap">
                                <span className='text-decoration-line-through me-2'>{originalValue}</span> {newValue}
                            </div>
                        </div>
                    </div>
                </div>
    }

    render() {
        const audits = this.props.audits;


        const convertToBlank = (value) =>{
            if(isStringNullOrEmpty(value)) return <i className='text-muted fs-90'>blank</i>;
            return value;
        }

        return <>
            
            <div class="table-responsive-xxl">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" style={{width:"200px"}}>Date &amp; Time</th>
                            <th scope="col" style={{width:"200px"}}>Action</th>
                            <th scope="col" style={{width:"120px"}}>Successed</th>
                            <th scope="col" style={{width:"180px"}}>User</th>
                            <th scope="col">Comments / Other Info</th>
                        </tr>
                    </thead>
                    <tbody>
                        {audits.map(a=>{
                            let showDasPayload = false;
                            let dasErrMsg;
                            if(a.externalApiPlatform=="DAS"){
                                if(a.externalApiResponseCode>400){
                                    dasErrMsg = JSON.parse(a.externalApiResponseContent).msg;
                                }
                                if(userRole.isSuperAdmin) {
                                    showDasPayload = true;
                                }
                            }
                        
                            return <tr>
                                <td>{moment((new Date(a.auditDate))).format('DD/MM/YYYY h:mma')}</td>
                                <td>{convertMeterAuditAction(a.auditAction)}</td>
                                <td>{a.actionSucceeded?<span className='text-success'>Yes</span>:<span className='text-danger'>Failed</span>}</td>
                                <td>{a.auditUser?<>{a.auditUser.firstname} {a.auditUser.lastname}</>:<i className='text-muted'>System</i>}</td>
                                <td>
                                    {showDasPayload && <button onClick={()=>this.onApiPayloadBtnClick(a)} className='btn btn-outline-secondary btn-sm float-end mx-2'><Info /></button>}
                                    {a.editMeterId && <button onClick={()=>this.onEditMeterDetailsBtnClick(a)} className='btn btn-outline-secondary btn-sm float-end mx-2'><Info /></button>}
                                    {a.comments}
                                    {dasErrMsg && <>{a.comments && <br/>}DAS message: <span className='text-danger'>{dasErrMsg}</span></>}
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>

            <div class="modal fade" id={this.#editMeterModalElemetnId} data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Edit Meter Details</h5>
                        </div>
                    <div class="modal-body">

                        {this.state.loadingEditMeter == true && <div className='text-center'><div class="spinner-border m-5" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div></div>}

                        {this.state.editMeter && <>
                            {this.renderInfoCorrectionRow(this.state.editMeter.manufacturerAndModelChanged,'Meter Manufacturer Model',this.state.editMeter.originalManufacturerAndModel,this.state.editMeter.newManufacturerAndModel)}
                            {this.renderInfoCorrectionRow(this.state.editMeter.otherManufacturerAndModelTextChanged,'Non-Pattern Approved Meter Details',convertToBlank(this.state.editMeter.originalOtherManufacturerAndModelText),convertToBlank(this.state.editMeter.newOtherManufacturerAndModelText))}
                            {this.renderInfoCorrectionRow(this.state.editMeter.patternApprovalNumberChanged,'Pattern Approval Number (if applicable)',convertToBlank(this.state.editMeter.originalPatternApprovalNumber),convertToBlank(this.state.editMeter.newPatternApprovalNumber))}
                            {this.renderInfoCorrectionRow(this.state.editMeter.meterSizeChanged,'Meter Size(mm)',this.state.editMeter.originalMeterSize,this.state.editMeter.newMeterSize)}
                            {this.renderInfoCorrectionRow(this.state.editMeter.meterSerialNoChanged,'Meter Serial Number',this.state.editMeter.originalMeterSerialNo,this.state.editMeter.newMeterSerialNo)}
                            {this.renderInfoCorrectionRow(this.state.editMeter.lidSerialNumberChanged,'LID Serial number',this.state.editMeter.originalLidSerialNumber,this.state.editMeter.newLidSerialNumber)}
                        </>}
                        
                    </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" disabled={this.state.loading} data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            
            <div class="modal fade" id={this.#payloadModalElementId} data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Payloads of API call history</h5>
                        </div>
                    <div class="modal-body">
                        {this.state.payloadAudit && <>
                            <div class="mb-3">
                                <label className="form-label">Request Payload</label>
                                <textarea className="form-control bg-white" readOnly={true} rows="5" value={this.state.payloadAudit.externalApiRequestPayload} />
                            </div>
                            <div class="mb-3">
                                <label className="form-label">Response Code</label>
                                <UneditableTextInput value={this.state.payloadAudit.externalApiResponseCode} />
                            </div>
                            <label className="form-label">Response Payload</label>
                            <textarea className="form-control bg-white" readOnly={true} rows="5" value={this.state.payloadAudit.externalApiResponseContent} />
                        </>}
                    </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" disabled={this.state.loading} data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    }
}

export default MeterAudits;
